import { render, staticRenderFns } from "./ObjectEditor.vue?vue&type=template&id=3aa77df1&scoped=true&"
import script from "./ObjectEditor.vue?vue&type=script&lang=js&"
export * from "./ObjectEditor.vue?vue&type=script&lang=js&"
import style0 from "./ObjectEditor.vue?vue&type=style&index=0&id=3aa77df1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa77df1",
  null
  
)

export default component.exports